/****************************************************************
 * File: pd-simple-navbar.tsx
 * Description: 简单的Navbar, 包含title和菜单列表，集成react-scroll
 * Author: zayfen <zhangyunfeng@pudutech.com>
 * Created: 2022/05/19 15:39
 *
 * History:
 *   Date               Programmer ID    Description
 *  -----------------  ---------------  ------------------------
 *  2022/05/19 15:39   zayfen           Init
 *
 * This unpublished material is proprietary to PuduTech.
 * All rights reserved. The methods and
 * techniques described herein are considered trade secrets
 * and/or confidential. Reproduction or distribution, in whole
 * or in part, is forbidden except by express written permission
 * of PuduTech.
 *****************************************************************/

import { FC } from 'react'
import NextLink from 'next/link'

import { Link } from 'react-scroll'

interface SimpleNavbarMenu {
  name: string
  element: string
}

export interface SimpleNavbarProps {
  containerId: string
  title: string
  menus: Array<SimpleNavbarMenu>
  link: string
}

const PdSimpleNavbar: FC<SimpleNavbarProps> = ({ title, menus, containerId, link }) => {
  return (
    <div
      id="simpleNavbar"
      className="w-full min-h-12 h-fit py-2 bg-white/80 shadow-lg backdrop-saturate-150 backdrop-blur-lg transition-all"
    >
      <div className="mx-auto w-300 h-full flex items-center justify-between gap-10">
        <NextLink href={link}>
          <h5 className="cursor-pointer flex-none">{title}</h5>
        </NextLink>

        <ul className="h-full flex items-center flex-wrap">
          {menus.map((menu) => (
            <li key={menu.element} className="w-fit h-fit">
              <Link
                className="block py-2 px-3 text-sm text-black/60 hover:bg-[#0066ff] hover:text-white cursor-pointer transition-all"
                containerId={containerId}
                activeClass="bg-[#0066ff] !text-white"
                to={menu.element}
                spy={true}
                hashSpy={true}
                smooth={true}
                duration={500}
              >
                {menu.name}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}

export default PdSimpleNavbar
